import React from "react";
import Layout from "app/components/layouts";
import IncomeDetailsPartOne from "app/components/Individual/incomeDetails/IncomeDetailsPartOne";
import LoanTypeStepper from "app/components/common/LoanTypeStepper";

const IncomeDetails: React.FC = () => {
  return (
    <>
      <Layout>
        <LoanTypeStepper />
        <IncomeDetailsPartOne />
      </Layout>
    </>
  );
};

export default IncomeDetails;
